/* Estratto da snippets/ames-accessori.liquid.
   Stava dentro l'HTML di ogni pagina: 3 KB non memorizzabili in cache,
   riscaricati e rianalizzati a ogni visita. Qui ha un indirizzo, quindi
   il browser lo prende una volta sola. Non contiene Liquid: le stringhe
   tradotte e gli indirizzi degli asset arrivano da variabili globali
   definite in layout/theme.liquid. */
(function () {
  'use strict';
  var modale = document.querySelector('[data-acc-modal]');
  if (!modale) return;
  var titolo = modale.querySelector('.ames-acc__title');
  var corpo  = modale.querySelector('[data-acc-body]');
  var T = window.AMES_ACC_T || {};
  var root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
  var apertoDa = null;
  var cache = {};

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function chiudi() {
    modale.hidden = true;
    document.documentElement.style.overflow = '';
    if (apertoDa) { apertoDa.focus(); apertoDa = null; }
  }

  /* Un prodotto alla volta e solo alla prima richiesta: la scheda porta i
     riferimenti, non i dati. */
  function prodotto(h) {
    if (cache[h]) return Promise.resolve(cache[h]);
    return fetch(root + 'products/' + h + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { cache[h] = d; return d; })
      .catch(function () { return null; });
  }

  function riga(d, perche) {
    if (!d) return '';
    var img = d.featured_image ? String(d.featured_image).replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
    return '<li class="ames-acc__row">' +
      '<a class="ames-acc__media" href="' + esc(d.url) + '" tabindex="-1" aria-hidden="true">' +
      (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" decoding="async" width="72" height="72">' : '') +
      '</a>' +
      '<div class="ames-acc__txt">' +
      '<a class="ames-acc__nome" href="' + esc(d.url) + '">' + esc(d.title) + '</a>' +
      (d.vendor ? '<span class="ames-acc__brand">' + esc(d.vendor) + '</span>' : '') +
      (perche ? '<p class="ames-acc__perche">' + esc(perche) + '</p>' : '') +
      '</div></li>';
  }

  function apri(bottone) {
    var dati;
    try { dati = JSON.parse(bottone.getAttribute('data-acc')); } catch (e) { return; }
    if (!dati || !dati.length) return;

    apertoDa = bottone;
    titolo.textContent = (T.titolo || 'Va bene insieme a') + ' ' + (bottone.getAttribute('data-acc-per') || '');
    corpo.innerHTML = '<p class="ames-acc__attesa">' + esc(T.attesa || 'Un momento…') + '</p>';
    modale.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    modale.querySelector('.ames-acc__close').focus();

    Promise.all(dati.map(function (v) { return prodotto(v[0]); })).then(function (ds) {
      var righe = ds.map(function (d, i) { return riga(d, dati[i][1]); }).filter(Boolean).join('');
      corpo.innerHTML = righe
        ? '<ul class="ames-acc__list">' + righe + '</ul>'
        : '<p class="ames-acc__attesa">' + esc(T.vuoto || 'Nessun accessorio disponibile.') + '</p>';
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-acc]');
    if (b) { e.preventDefault(); apri(b); return; }
    if (e.target.closest('[data-acc-close]')) { e.preventDefault(); chiudi(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modale.hidden) chiudi();
  });
})();
